/**
 * Do not edit directly
 * Generated on Thu, 05 Jan 2023 16:02:20 GMT
 */

export const DarkMode = {
  system: {
    strong: {
      neutral: "rgba(117, 117, 117, 1)",
      positive: "rgba(28, 132, 80, 1)",
      negative: "rgba(217, 54, 56, 1)",
      warning: "rgba(253, 184, 64, 1)",
      information: "rgba(49, 115, 201, 1)",
    },
    subtle: {
      neutral: "rgba(54, 61, 68, 1)",
      positive: "rgba(29, 74, 58, 1)",
      negative: "rgba(105, 43, 48, 1)",
      warning: "rgba(92, 69, 31, 1)",
      information: "rgba(38, 68, 106, 1)",
    },
  },
  accent: {
    primary: {
      strong: "rgba(251, 207, 9, 1)",
      medium: "rgba(251, 207, 9, 0.6)",
      subtle: "rgba(251, 207, 9, 0.2)",
    },
    secondary: {
      strong: "rgba(0, 151, 187, 1)",
      medium: "rgba(0, 151, 187, 0.6)",
      subtle: "rgba(0, 151, 187, 0.2)",
    },
    tertiary: {
      strong: "rgba(0, 60, 138, 1)",
      medium: "rgba(0, 60, 138, 0.6)",
      subtle: "rgba(0, 60, 138, 0.1)",
    },
  },
  background: {
    surface: "rgba(30, 36, 43, 1)",
    raised: "rgba(42, 48, 55, 1)",
    base: "rgba(20, 25, 31, 1)",
    section: "rgba(255, 255, 255, 0.04)",
    inactive: "rgba(255, 255, 255, 0.1)",
    inverted: "rgba(233, 236, 241, 1)",
    mask: "rgba(0, 0, 0, 0.15)",
  },
  border: {
    medium: "rgba(255, 255, 255, 0.1)",
    subtle: "rgba(255, 255, 255, 0.04)",
    strong: "rgba(255, 255, 255, 0.25)",
  },
  text: {
    onSurface: {
      strong: "rgba(255, 255, 255, 0.97)",
      subtle: "rgba(255, 255, 255, 0.57)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(0, 151, 187, 1)",
      hover: "rgba(0, 151, 187, 0.6)",
      visited: "rgba(185, 147, 189, 1)",
      positive: "rgba(28, 132, 80, 1)",
      negative: "rgba(217, 54, 56, 1)",
      warning: "rgba(253, 184, 64, 1)",
      information: "rgba(49, 115, 201, 1)",
    },
    onInverted: {
      strong: "rgba(54, 61, 68, 1)",
      subtle: "rgba(78, 84, 90, 1)",
      inactive: "rgba(179, 183, 188, 1)",
      link: "rgba(50, 97, 159, 1)",
      hover: "rgba(101, 137, 184, 1)",
      visited: "rgba(133, 71, 133, 1)",
    },
    onPrimary: {
      strong: "rgba(54, 61, 68, 1)",
      subtle: "rgba(78, 84, 90, 1)",
      inactive: "rgba(0, 0, 0, 0.25)",
      link: "rgba(54, 61, 68, 1)",
    },
    onSecondary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(0, 0, 0, 0.75)",
      inactive: "rgba(0, 0, 0, 0.25)",
      link: "rgba(0, 0, 0, 0.75)",
    },
    onTertiary: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(255, 255, 255, 0.57)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(255, 255, 255, 1)",
    },
    onFocus: {
      strong: "rgba(255, 255, 255, 1)",
      subtle: "rgba(0, 0, 0, 0.75)",
      inactive: "rgba(0, 0, 0, 0.25)",
      link: "rgba(0, 0, 0, 0.75)",
    },
    onBase: {
      strong: "rgba(255, 255, 255, 0.97)",
      subtle: "rgba(255, 255, 255, 0.57)",
      inactive: "rgba(255, 255, 255, 0.25)",
      link: "rgba(0, 151, 187, 1)",
      hover: "rgba(0, 151, 187, 0.6)",
      visited: "rgba(185, 147, 189, 1)",
    },
    onSystem: {
      strong: {
        neutral: "rgba(255, 255, 255, 1)",
        positive: "rgba(255, 255, 255, 1)",
        negative: "rgba(255, 255, 255, 1)",
        warning: "rgba(54, 61, 68, 1)",
        information: "rgba(255, 255, 255, 1)",
      },
      subtle: {
        neutral: "rgba(179, 183, 188, 1)",
        positive: "rgba(152, 203, 177, 1)",
        negative: "rgba(237, 164, 165, 1)",
        warning: "rgba(250, 211, 145, 1)",
        information: "rgba(147, 187, 239, 1)",
      },
    },
  },
  focus: {
    medium: "rgba(0, 151, 187, 0.4)",
    subtle: "rgba(0, 151, 187, 0.2)",
    strong: "rgba(0, 151, 187, 1)",
  },
  series: {
    1: "rgba(0, 151, 187, 1)",
    2: "rgba(50, 97, 159, 1)",
    3: "rgba(133, 71, 133, 1)",
    4: "rgba(228, 73, 76, 1)",
    5: "rgba(235, 135, 5, 1)",
    6: "rgba(251, 207, 9, 1)",
    7: "rgba(191, 215, 15, 1)",
    8: "rgba(0, 133, 66, 1)",
    9: "rgba(137, 207, 220, 1)",
    10: "rgba(0, 60, 138, 1)",
    11: "rgba(185, 147, 189, 1)",
    12: "rgba(221, 29, 33, 1)",
    13: "rgba(239, 160, 57, 1)",
    14: "rgba(252, 217, 59, 1)",
    15: "rgba(203, 221, 64, 1)",
    16: "rgba(51, 158, 106, 1)",
  },
  elevation: {
    level0: "0px 1px 3px rgba(0, 0, 0, 0.28), 0px 0px 1px rgba(0, 0, 0, 0.2)",
    level1: "0px 2px 5px rgba(0, 0, 0, 0.28), 0px 0px 2px rgba(0, 0, 0, 0.2)",
    level2: "0px 6px 24px rgba(0, 0, 0, 0.28), 0px 2px 6px rgba(0, 0, 0, 0.2)",
    level3:
      "0px 10px 40px rgba(0, 0, 0, 0.32), 0px 4px 12px rgba(0, 0, 0, 0.2)",
    level4:
      "0px 20px 64px rgba(0, 0, 0, 0.2), 0px 16px 24px rgba(0, 0, 0, 0.28)",
    level5:
      "0px 24px 80px rgba(0, 0, 0, 0.2), 0px 16px 32px rgba(0, 0, 0, 0.36)",
  },
};
